import { twMerge } from "tailwind-merge";
import { ImageWithPlaceholder } from "../ImageWithPlaceholder";
import { ForwardRefExoticComponent, RefAttributes } from "react";
import { LucideProps } from "lucide-react";

interface ImageWithDisplayNameProps {
  placeholderIcon?: ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>;
  imageClassName?: string;
  iconClassName?: string;
  imageUrl?: string;
  displayName?: string;
  displayNameClassName?: string;
  caption?: string;
  captionClassName?: string;
}

const ImageWithDisplayName = ({
  placeholderIcon,
  imageClassName,
  iconClassName,
  imageUrl,
  displayName,
  displayNameClassName,
  caption,
  captionClassName,
}: ImageWithDisplayNameProps) => {
  return (
    <div className="flex items-center gap-2">
      <ImageWithPlaceholder
        placeholderIcon={placeholderIcon}
        className={twMerge('w-6 h-6', imageClassName)}
        iconClassName={twMerge('w-4 h-4', iconClassName)}
        url={imageUrl}
      />

      <div className="flex flex-col">
        <p className={displayNameClassName}>
          {displayName || '--'}
        </p>

        {caption && (
          <p className={twMerge('text-[11px] font-light text-white-300 italic', captionClassName)}>
            {caption}
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageWithDisplayName;
